function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import StyledPill from "./pill.style";
import Icon from "../icon";
import tagComponent from "../../__internal__/utils/helpers/tags/tags";
import IconButton from "../icon-button";
let neutralWhiteWarnTriggered = false;
export const Pill = ({
  wrapText,
  borderColor,
  colorVariant = "neutral",
  isDarkBackground = false,
  children,
  fill = false,
  maxWidth,
  onClick,
  onDelete,
  pillRole = "tag",
  size = "M",
  ariaLabelOfRemoveButton = "remove pill",
  ...rest
}) => {
  if (!neutralWhiteWarnTriggered && !isDarkBackground && colorVariant === "neutralWhite" && !fill) {
    neutralWhiteWarnTriggered = true;
    // eslint-disable-next-line no-console
    console.warn("[WARNING] The `neutralWhite` variant should only be used on dark backgrounds with fill set to true. " + "Please set the `isDarkBackground` and `fill` props to true or use another color variant.");
  }
  return /*#__PURE__*/React.createElement(StyledPill, _extends({
    inFill: fill,
    colorVariant: colorVariant,
    isDarkBackground: isDarkBackground,
    isDeletable: !!onDelete,
    pillRole: pillRole,
    size: size,
    borderColor: borderColor,
    onClick: onClick
  }, tagComponent("pill", rest), {
    maxWidth: maxWidth,
    wrapText: wrapText
  }, rest), children, onDelete && /*#__PURE__*/React.createElement(IconButton, {
    onClick: onDelete,
    "data-element": "close",
    "aria-label": ariaLabelOfRemoveButton
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "cross"
  })));
};
export default Pill;